import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import BaseModalActions from 'components/Modals/BaseModalActions'
import { closeModal } from 'store/actions/modals'
import { t } from 'translations'

import { Button as MerinioButton, List } from 'ui'

const TableExportModal = ({ tableName }) => {
  const dispatch = useDispatch()
  const { [tableName]: options } = useSelector(state => state.tables)
  const { [`search-content-parsed-${tableName}`]: filter } = useSelector(state => state.settings)

  const { content } = options

  return (
    <BaseModalActions>
      {/* More options / Tools */}
      {options.exportCSV || options.exportPDF ? (
        <List className="pb-2">
          <List.Item className="pb-0">
            <h6>{t('components.table.EXPORT')}</h6>
          </List.Item>
          {options.exportCSV ? (
            <ListActionItem
              key={`dropdown-more-as-csv`}
              label={'components.table.EXPORT_AS_CSV'}
              onClick={async () => {
                if (!options._reloadCb) return options.exportCSV(content)

                if (options.customExportFunction) {
                  return options.exportCSV({ archived: options.archived, sortBy: options.sortBy, filter })
                }
                // Fetch the resources and export them
                const [result] = await options._reloadCb({ archived: options.archived, sortBy: options.sortBy, filter: options.filter })
                options.exportCSV(result)
                dispatch(closeModal())
              }}
            />
          ) : null}
          {options.exportPDF ? (
            <ListActionItem
              key={`dropdown-more-as-pdf`}
              label={'components.table.EXPORT_AS_PDF'}
              onClick={async () => {
                if (!options._reloadCb) return options.exportPDF(content)

                if (options.customExportFunction) {
                  return options.exportPDF({ archived: options.archived, sortBy: options.sortBy, filter })
                }
                // Fetch the resources and export them
                const [result] = await options._reloadCb({ archived: options.archived, sortBy: options.sortBy, filter: options.filter })
                options.exportPDF(result)
                dispatch(closeModal())
              }}
            />
          ) : null}
        </List>
      ) : null}
    </BaseModalActions>
  )
}

export default TableExportModal

const ListActionItem = ({ checked, disabled, icon, label, id, onClick, up }) => (
  <>
    <MerinioButton
      id={id}
      className={`list-group-item list-group-item-action${disabled ? ' disabled' : ''} px-4 list-group-flush`}
      onClick={() => {
        if (typeof onClick === 'function') onClick()
      }}
    >
      {checked && !icon ? <i className="far fa-check dropdown-check" /> : null}
      {checked && icon ? <i className={`far fa-sort-${icon}-${up ? 'up' : 'down'} dropdown-check`} /> : null}
      {t(label)}
    </MerinioButton>
  </>
)
